import * as React from "react";
import { forwardRef } from "react";
const SvgMoveDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-move-down-icon lucide-move-down", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 18L12 22L16 18" }), /* @__PURE__ */ React.createElement("path", { d: "M12 2V22" }));
const ForwardRef = forwardRef(SvgMoveDown);
export { ForwardRef as ReactComponent };
